import React from "react";
import "./The_Winning_Edge.css";
import Common_Heading from "../../common-components/common-heading/Common_Heading";
import Common_Card from "../../common-components/common-card/Common_Card";
import { Link, Navigate } from "react-router-dom";

function The_Winning_Edge() {
  const winningEdgeData = [
    {
      id: 1,
      icon: "/assets/images/winning-edge/withdraw.png",
      t1: "EASY",
      t2: "WITHDRAWAL",
      desc:
        "Get your winnings in your bank account easily. 24/7 automated processing system.",
    },
    {
      id: 2,
      icon: "/assets/images/winning-edge/best-odd.png",
      t1: "BEST",
      t2: "ODDS",
      desc:
        "Maximise your potential returns with the highest market odds. We guarantee value on every match.",
    },
    {
      id: 3,
      icon: "/assets/images/winning-edge/safe-secure.png",
      t1: "SAFE &",
      t2: "SECURE",
      desc:
        "End-to-end encrypted transactions and certified fair play. Your data & funds are always protected.",
    },
  ];

  return (
    <section className="winning-edge-section">
      <div className="container">
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 col-md-8 col-7">
            <div className="winning-edge-heading">
              <Common_Heading
                head1="THE WINNING,"
                head2="EDGE"
                title_text="WHY CHOOSE US?"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-4 text-lg-end col-5">
            <Link to="/aboutus">
              <button className="read-more-btn">READ MORE</button>
            </Link>
          </div>
        </div>

        <div className="row">
          {winningEdgeData.map((item) => (
            <div className="col-lg-4 col-md-6 mb-4 " key={item.id}>
              <Common_Card
                icon={item.icon}
                titleLine1={item.t1}
                titleLine2={item.t2}
                description={item.desc}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default The_Winning_Edge;
